var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadCv = function SvgUploadCv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 43,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FC470E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M23.75 30.889h5.64c4.083 0 7.422-2.453 7.422-7.021s-3.933-6.843-7.124-7.021c-.66-7.144-5.27-11.49-10.688-11.49-5.121 0-8.42 3.846-9.5 7.66-4.453.479-8.312 3.685-8.312 8.936s4.007 8.936 8.906 8.936h4.156"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FC470E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M23.75 21.482 19 16.107l-4.75 5.375M19 37.642v-20.19"
  })));
};
export default SvgUploadCv;